import Vue from "vue";
// import API from "app/axios";
import store from "./store";
import router from "./router";

/**
 *  Ascii
 *  https://patorjk.com/software/taag/#p=display&h=2&v=3&c=c%2B%2B&w=%20&f=ANSI%20Regular&t=Topic
 */

const userNotifyEngine = new Vue({
  router,
  store,

  data: function () {
    return {
        bootNotifStack: [],
    };
  },

  computed: {
    user() {
        return this.$store.getters.getAccount;
    },
  },

  methods: {

    uxOpenRecent(){
        this.notice(`Boot: Recent`);
        // if you implement this, merge the uxOpenReturn() end together/debouce
    },    
    uxOpenToday(){
        this.notice(`Boot: Today`);
        // if you implement this, merge the uxOpenReturn() end together/debouce
    },    
    uxOpenReturn(){
        this.notice(`Boot: Fresh!`);
        
        // consider all the boot items, suitable for a 'fresh' boot
        this.considerRatingFeedback();

        // now, fire one notification, shifted off the top of the array
        this.fireOneBootNotification();
    },

    fireOneBootNotification() {
        // sort written blind - check it's the right way around!! (then delete this comment)
        this.bootNotifStack.sort((a, b) => { return a.score > b.score; });

        const oNotif = this.bootNotifStack.shift();

        if (typeof oNotif.action !== 'function') {
            this.error(`[Boot] '${oNotif.name || 'Unknown'}' does not provide a callable action`);
            return;
        }

        this.notice(`[Boot] - Firing notification '${oNotif.name || 'Unknown'}' (score: ${oNotif.score})`);
        oNotif.action();
    },




    /**
     *  --------------------------- CONSIDER XYZ ------------------------------------
     *  
     *  Short patterns to consider rules for stacking various notifications: stage agnositic
     *  .. the decision to consider is taken elsewhere, for separation of responsibility.
     */


    considerRatingFeedback() {
        const iUserAge = this.$userEngine.getAge;
        const sRatingLast = this.$userEngine.getPref("nourish.interactions.rating.last");
        const iLastAsked = Math.floor((new Date() - new Date(sRatingLast || "1 Jan 1970")) / (86400 * 1000));

        this.notice(`[Rating] - Age: ${iUserAge} days, Last: ${iLastAsked} days (${sRatingLast})`);

        if ((iUserAge > 3) && (iLastAsked > 45)) {
            this.notice(`[Rating] - Ask!`);
            this.bootNotifStack.push({
                name: 'Rating',
                score: 50,
                action: () => {
                    this.EventBus.$emit('layer:new', {
                        component: 'app-review',
                    });
                    // only if it *actually* fires, record the date..
                    this.notice(`[Rating] - Recorded firing date...`);
                    this.$userEngine.setPref("nourish.interactions.rating.last", new Date());
                }
            });
        }
    },














    debug() {},

    notice() {
      // console.log(`\x1b[32muserNotifyEngine --`, ...arguments);
    },

    error() {
      // console.log(`\x1b[36muxEngine --`, ...arguments);
    },
  },

  created() {
    this.notice("Setting up listeners.. ");
    
    this.EventBus.$on("device:open:recent", this.uxOpenRecent);
    this.EventBus.$on("device:open:today", this.uxOpenToday);
    this.EventBus.$on("device:open:return", this.uxOpenReturn);
  },

  watch: {},
});

Object.defineProperties(Vue.prototype, {
  $userNotifyEngine: {
    get: function () {
      return userNotifyEngine;
    },
  },
});
